import { SxProps, Theme } from "@mui/material";

// Shared customer/lead form typography, matching the Figma design tokens.
// Field label — M3 "label/large - prominent" (Inter Semi Bold 14 / 20).
export const fieldLabelSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "20px",
  color: "#c5c6c9",
};

// Section header — M3 "title/large" (Inter Regular 22 / 28).
export const sectionTitleSx: SxProps<Theme> = {
  fontWeight: 400,
  fontSize: "22px",
  lineHeight: "28px",
  color: "#c5c6c9",
};
